import React from 'react'
import { Panel, Row, Col } from 'rsuite'

export default function ProjectBasicInfo({ schema, shaded = true }) {
  return (
    <>
      <Panel
        shaded={shaded}
        header={schema.projectBasicInfoHeader}
        bordered
        collapsible
        defaultExpanded
      >
        <div>
          <Row>
            {/* ชื่อโครงการ */}
            {schema.projectNameTitle && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <span>
                  {schema.projectNameTitle} :{' '}
                  <b>{schema.projectName ? schema.projectName : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {/* รหัสโครงการ */}
            {schema.projectCodeTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.projectCodeTitle} :{' '}
                  <b>
                    {schema.projectCode ? schema.projectCode : ' -ไม่ระบุ-'}{' '}
                    {schema.contractCode && `(เลขที่ข้อตกลง : ${schema.contractCode})`}
                  </b>
                </span>
              </Col>
            )}
            {/* รหัสข้อเสนอโครงการ */}
            {schema.projectRequestCodeTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.projectRequestCodeTitle} :{' '}
                  <b>{schema.projectRequestCode ? schema.projectRequestCode : ' -ไม่ระบุ-'} </b>
                </span>
              </Col>
            )}
            {/* ลักษณะโครงการ */}
            {schema.projectProposalStyleTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.projectProposalStyleTitle} :{' '}
                  <b>{schema.projectProposalStyle ? schema.projectProposalStyle : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {/* ประเภทข้อเสนอโครงการ */}
            {schema.projectProposalTypeTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.projectProposalTypeTitle} :{' '}
                  <b>{schema.projectProposalType ? schema.projectProposalType : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {/* ลักษณะกิจกรรม */}
            {schema.activityTypeTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.activityTypeTitle}
                  <span style={{ color: 'red' }}>{` ${schema.activityTypeTitle2}`}</span>
                  {' : '}
                  <b>{schema.activityType ? schema.activityType : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {/* ประเภทโครงการ */}
            {/* {schema.projectTypeTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.projectTypeTitle} :{' '}
                  <b>{schema.projectType ? schema.projectType : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )} */}
            {/* สถานะ */}
            {schema.statusTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.statusTitle} : <b>{schema.status ? schema.status : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {/* ชื่อผู้ประสาน */}
            {schema.staffNameTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.staffNameTitle} :{' '}
                  <b>{schema.staffName ? schema.staffName : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {/* ผู้รับทุน */}
            {schema.ownerNameTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.ownerNameTitle} :{' '}
                  <b>{schema.ownerName ? schema.ownerName : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {/* ระยะเวลาโครงการ */}
            {schema.projectPeriodTitle && (
              <>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <span>
                    {schema.projectPeriodTitle} :{' '}
                    <b>{schema.projectPeriod ? schema.projectPeriod : ' -ไม่ระบุ-'}</b>
                  </span>
                </Col>
              </>
            )}
          </Row>
          <Row>
            {/* ชื่อผู้รับผิดชอบโครงการ */}
            {schema.responsinatorNameTitle && (
              <>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <span>
                    {schema.responsinatorNameTitle} :{' '}
                    <b>{schema.responsinatorName ? schema.responsinatorName : ' -ไม่ระบุ-'}</b>
                  </span>
                </Col>
              </>
            )}{' '}
            {/* ขอขยายเวลามาแล้ว */}
            {schema.extendPeriodTitle && (
              <>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <span style={{ color: '#34c3ff' }}>
                    {schema.extendPeriodTitle} : <b>{schema.extendPeriodNo || '-'} ครั้ง</b>
                  </span>
                </Col>
              </>
            )}
          </Row>
        </div>
      </Panel>
    </>
  )
}
